import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CheckCircle, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPendenciaAceita = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    const resultado = acaoLower === 'pendência aceita' || 
           acaoLower === 'pendencia aceita' ||
           acaoLower.includes('pendência aceita') ||
           acaoLower.includes('pendencia aceita');
    return resultado;
};

const getIconPendenciaAceita = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: CheckCircle, color: 'var(--c2e86de)' };
};

export default function CardPendenciaAceita({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconPendenciaAceita(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const pendenciaAceitaConfig = {
    tipo: 'pendencia_aceita',
    detectaTipo: detectaPendenciaAceita,
    getIcon: getIconPendenciaAceita,
    temExpansao: () => true,
    Component: CardPendenciaAceita
};
